// ACTIVITY STATUS
export const GET_ACTIVITY_STATUSES = '/activity-status/query';
export const GET_ACTIVITY_STATUS = '/activity-status/';
export const POST_ACTIVITY_STATUS = '/activity-status/';
export const PUT_ACTIVITY_STATUS = '/activity-status/';
export const DELETE_ACTIVITY_STATUS = '/activity-status/';
